// extracted by mini-css-extract-plugin
export var bottomPagination = "PaginateProjects-module--bottomPagination--xBTna";
export var heading = "PaginateProjects-module--heading--+5xTW";
export var paginate = "PaginateProjects-module--paginate--2hhVh";
export var summary = "PaginateProjects-module--summary--j9DR-";
export var topInfo = "PaginateProjects-module--topInfo--ckQdh";